import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'environments/environment';
import {Popover} from 'primeng/popover';

interface QuickAccessItem {
    name: string;
    icon: string;
    url: string;
}

@Component({
    selector: 'app-quick-access-panel',
    templateUrl: './quick-access-panel.component.html',
    styleUrls: ['./quick-access-panel.component.scss'],
    standalone: true,
  imports: [CommonModule, TranslateModule, Popover],
})
export class QuickAccessPanelComponent {
    @Output() panelToggle = new EventEmitter<boolean>();

    @ViewChild('op') popover!: Popover;

    items: QuickAccessItem[] = [
        { name: 'menu.quickAccess.exploitation', icon: '/assets/images/quick-access/engie.ico', url: environment.quickAccess.exploitation },
        { name: 'menu.quickAccess.analyse', icon: '/assets/images/quick-access/analyse.svg', url: environment.quickAccess.analyse },
        { name: 'menu.quickAccess.synoptique', icon: '/assets/images/quick-access/engie.ico', url: environment.quickAccess.synoptique },
        { name: 'menu.quickAccess.clientArea', icon: '/assets/images/quick-access/client-area.svg', url: environment.quickAccess.clientArea },
        { name: 'menu.quickAccess.daf', icon: '/assets/images/quick-access/daf.png', url: environment.quickAccess.daf },
        { name: 'menu.quickAccess.lng', icon: '/assets/images/quick-access/lng.png', url: environment.quickAccess.lng },
    ];

    toggle(event: Event) {
        this.popover.toggle(event);
    }
}
